import { render, staticRenderFns } from "./ModalConfigCanchas.vue?vue&type=template&id=f978cd66&scoped=true&"
import script from "./ModalConfigCanchas.vue?vue&type=script&lang=js&"
export * from "./ModalConfigCanchas.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigCanchas.vue?vue&type=style&index=0&id=f978cd66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f978cd66",
  null
  
)

export default component.exports